export var flushBodiedSyncBlocks = function flushBodiedSyncBlocks(syncBlockStore) {
  return syncBlockStore.flushBodiedSyncBlocks();
};